/* eslint-disable no-unused-vars */
import React from "react";
import "./SalesReport.css";
import SalesReportTable from "./SalesReportTable";
import SalesReportController from "./SalesReportController";
import calendarIcon from "../../../../../assets/Image/calender.png";

const SalesReport = () => {
  const {
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    selectedVendor,
    handleVendorChange,
    vendors,
    products,
    selectedProduct,
    handleProductChange,
    selectedInvoice,
    handleInvoiceChange,
    filteredInvoices,
    reportData,
    handleFetchReport,
    allproductbyvendor,
    singleInvoiceProfit = [], // Default to an empty array if undefined
    perProductProfit,
    perProductId,
    invoiceDetails,
    loading,
    
  } = SalesReportController();

  // console.log("Selected Product: ", selectedProduct);
  // console.log("Single Invoice Profit Data: ", singleInvoiceProfit);

  // Filter singleInvoiceProfit based on the selected product name
  // If no product is selected, show all data, else filter by the selected product
  const filteredData = (singleInvoiceProfit || []).filter((item) => {
    // If no product is selected, return true for all items
    if (!selectedProduct) return true;
    // Otherwise, filter based on whether the selected product is in the products array
    return item.products && item.products.includes(selectedProduct);
  });
  return (
    <div className="inventory-container">
      <div className="inventory-header">
        <div className="inventory-title">Reports</div>
      </div>

      <div className="filters-row">
        <div
          className="date-range"
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        >
          <img
            src={calendarIcon}
            alt="Calendar"
            style={{
              marginLeft: "10px",
              width: "16px",
              height: "16px",
            }}
          />
          <div
            className="date-input-wrapper"
            style={{ position: "relative", paddingRight: "0px" }}
          >
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="filter-input"
              style={{
                border: "none",
                outline: "none",
                padding: "8px",
                borderRadius: "8px 0 0 8px",
                width: "130px",
                appearance: "none",
              }}
            />
          </div>
          <span className="text-gray-600" style={{ margin: "0 0px" }}>
            to
          </span>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="filter-input"
            style={{
              border: "none",
              outline: "none",
              padding: "8px",
              borderRadius: "0 8px 8px 0",
              width: "130px",
              appearance: "none",
            }}
          />
        </div>

        <select
          value={selectedVendor}
          onBlur={handleFetchReport}
          onChange={(e) => handleVendorChange(e.target.value)}
          className="form-control-borderless product"
          style={{ width: "240px" }}
        >
          <option value="">Select Vendor</option>
          {vendors
            .filter(
              (vendor) => vendor.type === "purchase" && !vendor.is_deleted
            )
            .map((vendor) => (
              <option key={vendor.id} value={vendor.id}>
                {vendor.name}
              </option>
            ))}
        </select>

        <select
          value={selectedProduct}
          onChange={(e) => handleProductChange(e.target.value)}
          className="form-control-borderless product"
          style={{ width: "240px" }}
          disabled={!selectedVendor}
        >
          <option value="">Select Product</option>
          {products.length > 0 ? (
            products.map((product) => (
              <option key={product.product_id} value={product.product_name}>
                {product.product_name}
              </option>
            ))
          ) : (
            <option disabled>No products available</option>
          )}
        </select>

        {/* <select
          value={selectedInvoice}
          onChange={(e) => handleInvoiceChange(e.target.value)}
          className="form-control-borderless product"
          style={{ width: "240px" }}
          disabled={!selectedProduct}
        >
          <option value="">Select Invoice</option>
          {filteredInvoices.map((invoice) => (
            <option key={invoice.invoice_id} value={invoice.invoice_id}>
              Invoice No {invoice.invoice_number}
            </option>
          ))}
        </select> */}
      </div>

      <div className="container report">
        <div className="report-title">Sales Report</div>
        {startDate && endDate && (
          <div className="report-dates">
            <span>
              {startDate} to {endDate}
            </span>
          </div>
        )}
        <SalesReportTable
          data={filteredData || singleInvoiceProfit}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default SalesReport;
